module.exports = __webpack_public_path__ + "static/flatart-insta-ss1-b57912d58e5961455e33c31ee53c3eef.png";